import React from 'react';
import PropTypes from 'prop-types';

import GroupSetInner from './GroupSetInner';
import Dialog from '../../../common/Dialog';

const CreateGroupSetDialog = ({ open, onClose, saving, onSave }) => (
  <Dialog id="create-set" open={open} onClose={onClose}>
    <GroupSetInner
      mode="create"
      saving={saving}
      onSave={onSave}
      onClose={onClose}
    />
  </Dialog>
);

CreateGroupSetDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default CreateGroupSetDialog;
